// extracted by css-extract-rspack-plugin
export default {"LeadingIconButtonContainer":"leading-icon-button-module__LeadingIconButtonContainer__Na0BU"};